import config from "../../assets/js/conf/config";
import { request } from "../../assets/js/utils/request";


//产品列表
export function getGoodsData(data) {
  return request(config.baseApi + "/goods/product_list", "post", data)
}

//搜索列表
export function getGoodsSearchData(data) {
  return request(config.baseApi + "/goods/search_sort", "post", data)
}

//产品详情
export function getDetailsData(data) {
  return request(config.baseApi + "/goods/see_product", "post", data)
}

//产品收藏/取消收藏
export function setCollectionData(data) {
  return request(config.baseApi + "/goods/collection", "post", data)
}

